<script lang="ts">
    import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from 'sveltestrap';
    import {modal_box, close} from '../store/ModalBox';

</script>

    <Modal isOpen={$modal_box.open} toggle={() => { close()} }>
        <ModalHeader toggle={() => { close()} }>{$modal_box.title}</ModalHeader>
        <ModalBody>
            {$modal_box.text}{@html $modal_box.html}
            {#each $modal_box.inputs as input}
                <FormGroup>
                    <Label for="">{input.label}</Label>
                    {(() => {
                        let input_html = '';
                        if ("type" in input && input.type=="number") {
                            input_html += '<div><input type="number" class="form-control input-field" ';
                            if ("min" in input) input_html += ` min="${input.min}" `;
                            if ("max" in input) input_html += ` max="${input.max}" `;
                            if ("step" in input) input_html += ` step="${input.step}" `;
                            if ("default_value" in input) input_html += ` value="${input.default_value}" `;
                            input_html+=  '></div>';
                        } else if ("type" in input && input.type=="date") {
                            input_html += '<div><input type="date" class="form-control input-field" ';
                            if ("min" in input) input_html += ` min="${input.min}" `;
                            if ("max" in input) input_html += ` max="${input.max}" `;
                            if ("default_value" in input) input_html += ` value="${input.default_value}" `;
                            input_html += '></div>';
                        } else if ("type" in input_html && input_html.type=="datetime") {
                            input_html += '<div><input type="datetime-local" class="form-control input-field" ';
                            if ("min" in input_html) input_html += ` min="${input_html.min}" `;
                            if ("max" in input_html) input_html += ` max="${input_html.max}" `;
                            if ("step" in input_html) input_html += ` step="${input_html.step}" `;
                            if ("default_value" in input_html) input_html += ` value="${input_html.default_value}" `;
                            input_html += '></div>';
                        } else if ("type" in input_html && input_html.type=="select") {
                            input_html += '<div><select class="form-control input-field">';
                            if ("options" in input_html) {
                                for (const o of input_html.options) {
                                    if ("selected" in o && o.selected)
                                        input_html += `<option value="${o.value}" SELECTED>${o.text}</option>`;
                                    else
                                        input_html += `<option value="${o.value}">${o.text}</option>`;
                                }
                            }
                            input_html += '</select></div>';
                        } else if ("type" in input_html && input_html.type=="password") {
                            input_html += '<div><input type="password" class="form-control input-field"></div>';
                        } else {
                            input_html += '<div><input type="text" class="form-control input-field"></div>';
                        }

                        return input_html;
                    })()}

                </FormGroup>
            {/each}
        </ModalBody>
        <ModalFooter>
            {#each $modal_box.buttons as button}
                <Button color="{button.color}" on:click={() => { button.callback() }}>{button.label}</Button>
            {/each}
        </ModalFooter>
    </Modal>
